import React from 'react';
import BaseIcon, { IconProps } from '../Base.icon';

const LogoBlueIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 256 256">
      <circle cx="127.594" cy="96.594" r="91.594" fill="#206FE2" />
      <path
        d="M142.819 88.1404V102.145H112.424V88.1404H142.819ZM112.424 55.5734V136.491H94.4404V55.5734H112.424ZM160.748 55.5734V96.0321V136.491H142.819V55.5734H160.748Z"
        fill="white"
      />
      <path
        d="M83.2018 193.807C111.648 207.319 144.664 207.319 173.11 193.807L179.853 250L128.156 226.399L76.4587 250L83.2018 193.807Z"
        fill="#206FE2"
      />
    </BaseIcon>
  );
};

export default LogoBlueIcon;
